module.exports = __webpack_public_path__ + "a2d5785ed6379fed635a829a945df5d8.jpg";